import { resolveMenu } from "./navigationRegistry";
import { useNavContext } from "../contexts/NavContext";

// Build a PageHeader tab strip from a navigation-registry group id. Returns
// { tabs, activeKey } where `tabs` are ready descriptors ({ key, label, onClick,
// disabled }) permission-filtered by the registry (the same gating the nav menu
// applies), and `activeKey` is the child whose live URL matches the current path.
// Hand the result straight to PageHeader:
//
//   const { tabs, activeKey } = useNavMenu("report-cards");
//   <PageHeader title="Report Cards" tabs={tabs} activeTab={activeKey} />
//
// Requires a NavProvider ancestor (mounted in the School layout). Without one it
// returns an empty strip rather than throwing, so a header outside that scope
// simply renders no tabs.
export default function useNavMenu(id) {
  const nav = useNavContext();
  const links = nav ? resolveMenu(id, nav.ctx) : [];
  const tabs = links.map((link) => ({
    key: link.key,
    label: link.label,
    disabled: link.disabled,
    onClick:
      link.disabled || !link.url
        ? undefined
        : () => nav.navigate(link.url, link.v1),
  }));
  const active =
    nav &&
    links.find(
      (link) => link.url && link.url.split("?")[0] === nav.currentPath
    );
  return { tabs, activeKey: active ? active.key : undefined };
}
